import { Component, ViewChild, OnDestroy, OnInit, Inject, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MatPaginator, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule, Sort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { Router, RouterLink } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatDialogModule} from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { BehaviorSubject, Subscription } from 'rxjs';
import { AdminQueriesService } from '../../api/adminQueries.service';
import { SafelyPortalAPIService } from '../../api/safelyPortalAPI.service';
import { Pageable } from '../../models/pageable';
import { Referral } from '../../models/referral';
import { ReferralRow } from '../../models/referral-row';
import { ReferralDTO } from '../../models/referralDTO';
import { Logger } from '../../../../infrastructure/logging/logger';

@Component({
  selector: 'app-referral',
  templateUrl: './referral.component.html',
  styleUrls: ['./referral.component.scss'],
  standalone: true,
  imports: [
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatDividerModule,
    ReactiveFormsModule,
    MatCardModule,
    MatFormFieldModule,
    CurrencyPipe,
    MatSlideToggleModule,
    MatPaginatorModule,
    MatTableModule,
    CommonModule,
    RouterLink,
    FormsModule,
    MatSnackBarModule,
    MatTableModule,
    MatFormFieldModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    FormsModule,
    MatProgressSpinner
  ]
})
export class ReferralComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort: MatSort = new MatSort;

  api: SafelyPortalAPIService;
  queryApi: AdminQueriesService;
  sub = new Subscription();

  displayedColumns: string[] = ['referralCode', 'legacyOrganizationId', 'amount', 'type', 'status', 'delete'];
  dataSource: MatTableDataSource<ReferralRow> = new MatTableDataSource<ReferralRow>;

  loading = new BehaviorSubject<boolean>(false);
  selection = new SelectionModel<ReferralRow>(false, []);
  filterValue = "";
  totalElements = 0;
  referrals: ReferralDTO[] = [];
  router: Router;
  pageNumber: number = 1;
  tableLength = 0;
  pageSize = 10;

  initialKeyword = new BehaviorSubject<string>('');
  initialSort = new BehaviorSubject<Sort | undefined>(undefined);
  initialPageSize = new BehaviorSubject<number>(10);
  initialPageNumber = new BehaviorSubject<number>(1);

  constructor(
    apiService: SafelyPortalAPIService, 
    queryService: AdminQueriesService,
    router: Router, 
    public dialog: MatDialog, 
    private snackbar: MatSnackBar,
    private logService: Logger,
    private cdr: ChangeDetectorRef
  ) {
    this.api = apiService;
    this.queryApi = queryService;
    this.router = router;
  }

  ngOnInit(): void {
    this.loading.next(true);
    this.refreshData({}, "");

    const storedItemsPerPage = localStorage.getItem('referralItemsPerPage');
    if (storedItemsPerPage) {
      this.initialPageSize.next(parseInt(storedItemsPerPage, 10));
    } else {
      this.initialPageSize.next(10);
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;

    this.initialPageSize?.subscribe(pageSize => {
      this.pageSize = pageSize;
      this.paginator.pageSize = pageSize;
      this.cdr.detectChanges();
    });

    this.initialPageNumber?.subscribe(pageNumber => {
      if (pageNumber != 1) {
        this.pageNumber = pageNumber;
        this.paginator.pageIndex = pageNumber;
      } else {
        this.pageNumber = 1;
      }
      this.cdr.detectChanges();
    });

    this.initialKeyword?.subscribe(keyword => {
      this.filterValue = keyword;
      this.cdr.detectChanges();
    });

    this.initialSort?.subscribe(sort => {
      if (!sort) {
        return;
      }

      this.setSort(sort);
      this.cdr.detectChanges();
    });
  }

  setSort(sort: Sort) {
    this.sort.sort({ id: sort.active, start: sort.direction, disableClear: false });
  }

  ngOnDestroy(): void {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  applyFilter(event: Event) {
    this.filterValue = (event.target as HTMLInputElement).value;

    if (this.paginator) {
      let pg: Pageable = {};
      pg.page = 0;
      pg.size = this.paginator.pageSize;

      this.refreshData(pg, this.filterValue);
      this.paginator.firstPage();
    }
  }

  public refreshData(pageable: Pageable, search: string) {
    if (!pageable) {
      pageable = { size: this.paginator.pageSize }
    }
    return this.queryApi.getAllReferrals(pageable, search).subscribe(result => {
      this.referrals = result.content ? result.content : [];
      this.dataSource.data = ReferralRow.mapRowsFromReferralDTO(result.content);

      this.totalElements = result.totalElements ? result.totalElements : 0;
      this.dataSource.sort = this.sort;
      this.loading.next(false);
    });
  }

  public updateStatus($event: any, row: ReferralRow) {
    if ($event && $event.checked == true) {
      if (this.referrals) {
        let referral = this.referrals.filter(ref => ref.id === row.id);
        if (referral && referral.length > 0) {
          referral[0].status = 'ACTIVE';
          let referralToUpdate = Referral.fromDTO(referral[0]);
          if (referralToUpdate)
            this.api.updateReferral(referralToUpdate?.toUpdateReferralCommand()).subscribe({
              next: (value) => {
                this.snackbar.open('Status updated successfully', 'OK', { duration: 3000 });
              },
              error: (err) => {
                this.snackbar.open('Could not update referral status. Please try again', 'OK', { duration: 3000 });
              },
            });
        }
      }
    } else if ($event && $event.checked == false) {
      if (this.referrals) {
        let referral = this.referrals.filter(ref => ref.id === row.id);
        if (referral && referral.length > 0) {
          referral[0].status = 'INACTIVE';
          let referralToUpdate = Referral.fromDTO(referral[0]);
          if (referralToUpdate)
            this.api.updateReferral(referralToUpdate?.toUpdateReferralCommand()).subscribe({
              next: (value) => {
                this.snackbar.open('Status updated successfully', 'OK', { duration: 3000 });
              },
              error: (err) => {
                this.snackbar.open('Could not update referral status. Please try again', 'OK', { duration: 3000 });
              },
            });
        }
      }
    }
  }

  onPageEvent(event: PageEvent): void {
    this.pageNumber = event.pageIndex + 1;
    localStorage.setItem('referralItemsPerPage', event.pageSize.toString());
  }

  clearSearch() {
    this.filterValue = '';
    this.refreshData({}, "");
  }

  public showDetail(row: ReferralRow) {
    this.router.navigate([`../referrals/${row.id}`]);
  }

  pageEvent(page: PageEvent) {
    let pageable: Pageable = {};
    pageable.size = page.pageSize;
    pageable.page = page.pageIndex;
    this.refreshData(pageable, this.filterValue);
  }

  openDeleteDialog(row: ReferralRow): void {
    const dialogRef = this.dialog.open(DeleteReferralDialog, {
      width: '50%',
      data: { 
        result: false, 
        name: row.referralCode 
      },
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.result == true) {
        if (row && row.id) {
          this.api.deleteReferral(row.id).subscribe(
            {
              next: (value) => {
                let pg: Pageable = {};
                pg.size = this.paginator.pageSize;
                pg.page = this.paginator.pageIndex;
                this.refreshData(pg, this.filterValue);
                this.snackbar.open(`Deleted referral code ${row.referralCode}`, 'OK', { duration: 3000 });
              },
              error: (err) => {
                this.snackbar.open(`Could not delete referral code ${row.referralCode}. Please try again`, 'OK', { duration: 3000 });
              },
            });
        }
      }
    });
  }

  onGoToPageClick() {
    const max = Math.trunc(Math.ceil(this.paginator.length / this.paginator.pageSize));
    if (this.pageNumber < 1) {
      this.resetPaginator(1, true);
      this.displayInvalidPaginatorPageIndexError();
    } else if (this.pageNumber > max) {
      this.resetPaginator(max, false);
      this.displayInvalidPaginatorPageIndexError();
    } else {
      this.paginator.pageIndex = this.pageNumber - 1;
      this.paginator.page.next({
        pageIndex: this.pageNumber - 1,
        pageSize: this.paginator.pageSize,
        length: this.paginator.length
      });
    }
  }

  resetPaginator(pageNumber: number, goToFirstPage: boolean) {
    this.pageNumber = pageNumber;

    if (this.paginator) {
      if (goToFirstPage) {
        this.paginator.firstPage();
      } else {
        this.paginator.lastPage();
      }
    }
  }

  displayInvalidPaginatorPageIndexError() {
    this.snackbar.open('Invalid page number', 'OK', { duration: 3000 });
  }
}

@Component({
  selector: 'delete-referral-dialog',
  template: `
    <div class="p-2">
      <h1 mat-dialog-title>Delete Referral</h1>

      <div mat-dialog-content class="my-2">
        <p>Are you sure you want to delete referral code <strong>{{data.name}}</strong>?</p>
      </div>
      <div mat-dialog-actions>
        <button mat-raised-button (click)="onNoClick()" style="margin-right:8px">
          Cancel
        </button>
        <button mat-raised-button class="warn-button" [mat-dialog-close]="data" (click)='onYesClick()' cdkFocusInitial>
          Delete
        </button>
      </div>
    </div>
  `,
  standalone: true,
  imports: [ 
    MatDialogModule, 
    MatButtonModule 
  ]
})
export class DeleteReferralDialog {
  constructor(
    public dialogRef: MatDialogRef<DeleteReferralDialog>,
    @Inject(MAT_DIALOG_DATA) public data: { result: boolean, name: string }
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }
  onYesClick() {
    this.data.result = true;
  }
}